module.exports = __webpack_public_path__ + "img/scross.778478b9.png";